import {DashboardLayout} from "../../layout/dashboard.layout";
import {useTranslation} from "react-i18next";
import {DASHBOARD, NUMBERS} from "../../../routes/frontend.routes";
import React, {useEffect, useState} from "react";
import {Link, useParams} from "react-router-dom";
import {NumberForm} from "./form";
import {jsonRequest} from "../../../../api/request/request";
import {NUMBER_EDIT, NUMBER_GET} from "../../../../api/routing/routes/admin.backend.app";
import {HttpException, UnprocessableEntityException} from "../../../../lib/http/exception/http.exception";
import {useAlert} from "react-alert";
import {useNavigate} from "react-router";
import {NumberModel} from "../../../../api/model/number";
import {ReactSelectOptionProp} from "../../../../app-frontend/containers/dashboard/send.messages";

export const UpdateNumber = () => {
  const {t} = useTranslation();
  const alert = useAlert();
  const params = useParams();
  const id = params.id as string;

  const [isSubmitting, setSubmitting] = useState(false);
  const [errors, setErrors] = useState([]);
  const navigate = useNavigate();
  const [number, setNumber] = useState<NumberModel>();

  const loadNumber = async () => {
    try {
      const res = await jsonRequest(NUMBER_GET.replace(':id', id));
      const json = await res.json();

      setNumber(json.number);
    } catch (e) {
      if (e instanceof HttpException) {
        alert.error(e.message);
      }

      throw e;
    }
  }

  useEffect(() => {
    loadNumber();
  }, []);

  const onSubmit = async (values: any) => {
    setSubmitting(true);
    setErrors([]);

    if(values.groups){
      const groups = values.groups;
      values.groups = groups.map((item: ReactSelectOptionProp) => {
        return item.value;
      });
    }

    try {
      await jsonRequest(NUMBER_EDIT.replace(':id', id), {
        method: 'POST',
        body: JSON.stringify(values)
      });

      navigate(NUMBERS);
    } catch (e) {
      if (e instanceof UnprocessableEntityException) {
        const err = await e.response.json();
        setErrors(err.violations);
      }

      if (e instanceof HttpException) {
        alert.error(e.message);
      }

      throw e;
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <DashboardLayout
      title="Numbers"
      breadCrumbs={[
        {title: t('Dashboard'), link: DASHBOARD},
        {title: t('Numbers'), link: NUMBERS},
        {title: t('Update'), current: true},
      ]}
      buttons={[
        <Link to={NUMBERS} className="float-end btn btn-primary">{t('Back to list')}</Link>
      ]}
    >
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">
                {t('Update')}
              </h5>
              <NumberForm
                onSubmit={onSubmit}
                isSubmitting={isSubmitting}
                errors={errors}
                number={number}
              />
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};
